import React from 'react';

const Background: React.FC = () => {
  return (
    <div 
      className="fixed inset-0 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: 'url(/background.jpg)',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-20" />
    </div>
  );
};

export default Background;
